import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

// shared modules
import { SharedModule } from '../shared/shared.module';

// containers
import { AccessAccountSectionComponent } from './containers/access-account-section/access-account-section.component';
import { VerifyEmailSectionComponent } from './containers/verify-email-section/verify-email-section.component';
import { ForgotPasswordSectionComponent } from './containers/forgot-password-section/forgot-password-section.component';
import { ResetPasswordSectionComponent } from './containers/reset-password-section/reset-password-section.component';
import { AccessOptionsSectionComponent } from './containers/access-options-section/access-options-section.component';
import { AccessAccountOtpSectionComponent } from './containers/access-account-otp-section/access-account-otp-section.component';

// components
import { VerifyEmailComponent } from './components/verify-email/verify-email.component';
import { ForgotPasswordComponent } from './components/forgot-password/forgot-password.component';
import { LoginOptionsComponent } from './components/login-options/login-options.component';

// routing
// import { routing } from './login.routing';


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule
  ],
  declarations: [
    AccessAccountSectionComponent,
    VerifyEmailSectionComponent,
    VerifyEmailComponent,
    ForgotPasswordSectionComponent,
    ForgotPasswordComponent,
    ResetPasswordSectionComponent,
    AccessOptionsSectionComponent,
    LoginOptionsComponent,
    AccessAccountOtpSectionComponent
  ]
})
export class LoginSectionModule { }
